// 网球 【中网】
export default {
  data() {
    return {
      bigSportsList: [
        {
          id: 'TEN',
          CN: '网球',
          EN: 'Tennis',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_19',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_19',
              },
            ],
          },
        },
      ],
    }
  },
}
